import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { useAuth } from 'context/AuthContext';
import { safeJSONParse } from 'utils/helpers/safeParsing';

const ClientsContext = createContext<any>(null);

export const useClients = () => useContext(ClientsContext);

export const defaultClientsStatus = [0, 1];

export const ClientsProvider = ({ children }: { children: ReactNode }) => {
    const { auth } = useAuth();
    const filterName = `voltox-${auth.user.ID}-clients-filter`;
    const orderName = `voltox-${auth.user.ID}-clients-order`;
    const descName = `voltox-${auth.user.ID}-clients-desc`;

    const [showSpinner, setShowSpinner] = useState(false);
    const [listResetNonce, setListResetNonce] = useState(0);
    const [listRefreshNonce, setListRefreshNonce] = useState(0);
    const [clientsOrder, setClientsOrder] = useState(safeJSONParse(sessionStorage.getItem(orderName)) || '');
    const [clientsDesc, setClientsDesc] = useState(safeJSONParse(sessionStorage.getItem(descName)) === true);
    const [clientsStatus, setClientsStatus] = useState<number[]>(
        safeJSONParse(sessionStorage.getItem(filterName)) || defaultClientsStatus,
    );

    const triggerListReset = () => setListResetNonce((nonce) => nonce + 1);
    const triggerListRefresh = () => setListRefreshNonce((nonce) => nonce + 1);

    useEffect(() => {
        sessionStorage.setItem(filterName, JSON.stringify(clientsStatus));
    }, [clientsStatus]);

    useEffect(() => {
        sessionStorage.setItem(orderName, JSON.stringify(clientsOrder));
    }, [clientsOrder]);

    useEffect(() => {
        sessionStorage.setItem(descName, JSON.stringify(clientsDesc));
    }, [clientsDesc]);

    return (
        <ClientsContext.Provider
            value={{
                showSpinner,
                setShowSpinner,
                clientsOrder,
                setClientsOrder,
                clientsDesc,
                setClientsDesc,
                clientsStatus,
                setClientsStatus,
                listResetNonce,
                triggerListReset,
                listRefreshNonce,
                triggerListRefresh,
            }}
        >
            {children}
        </ClientsContext.Provider>
    );
};
